import err_icon from './img/err_icon.svg'
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import { TextPage } from '../../TextPage/TextPage';
import './ModalErr.scss'

const ModalErr = ({
    setIsModal
}) => {

    return (
        <ModalComponent
            title='Что-то пошло не так'
            onClose={() => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: 'fit-content'
            }}
            child={
                <div className='modal-err'>
                    <img width={60} height={60} src={err_icon} alt='icon'/>

                    <TextPage
                        text='Попробуйте перезагрузить страницу'
                    />

                    <ButtonBasic
                        blue
                        text='Ок'
                        onClick={(e) => setIsModal(false)}
                    />
                </div>
            }
        />
    )
}

export { ModalErr }